import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocSessionPeriodState = atom({
  key: "ocSessionPeriodState",
  default: 0,
  effects_UNSTABLE: [ocPersistAtom],
});
